import React from 'react';
import { withRouter, RouteComponentProps, Route } from 'react-router';
import { Redirect } from './Redirect';
import * as QS from 'query-string';
import { Action, Location } from 'history';
import { triggerJumpTrackReport } from '../../../../shared/common/trackReport';

const routerProps: RouteComponentProps = {} as any;

const RedirectRouter = '/Redirect';

const ___REFERER_URL_MAP = '___REFERER_URL_MAP'; // 全局保存的跳转信息

class RCRouterEntry extends React.Component<RouteComponentProps<any>, any> {

    constructor(props, context) {
        super(props, context);

        Object.assign(routerProps, props);
    }

    public render(): React.ReactNode {
        return <Route key={ '/Redirect' } component={ Redirect } />;
    }
}

const encodeURINames = ['productDeployPage'];

const RouterEntry = withRouter(RCRouterEntry);

export interface IUrlObj {
    pathname: string;
    search: string;
}

interface IJumpInfoObject {
    [key: string]: IUrlObj;
}

/**
 * @description 本地存储当前页面跳转信息
 * @param obj 目标页面
 */
function storeJumpInfo(url: string) {
    const urlArr = url.split('?');
    const currentPathname: string = (urlArr[0].indexOf(router.path) === 0 ? '' : router.path) + urlArr[0];
    if (currentPathname === location.pathname) { // 页面path不变则不需要存储
        return;
    }
    const jumpInfoObj: IJumpInfoObject = JSON.parse(localStorage.getItem(___REFERER_URL_MAP) || '{}');
    const value: IUrlObj = {
        pathname: location.pathname,
        search: location.search
    };
    jumpInfoObj[currentPathname] = value;
    localStorage.setItem(___REFERER_URL_MAP, JSON.stringify(jumpInfoObj));
}

/**
 * @description 如果没有跳转信息，返回false；如果有，router到跳转前的页面，并返回true
 */
function hasJumpInfo(realPathname?: string): boolean {
    const jumpInfoObj: IJumpInfoObject = JSON.parse(localStorage.getItem(___REFERER_URL_MAP) || '{}');
    const pathname = realPathname || window.location.pathname;
    if (jumpInfoObj[pathname]) {
        // 不用push 以防记录history
        router.routerProps.history
            && router.routerProps.history.replace(jumpInfoObj[pathname].pathname + jumpInfoObj[pathname].search);
        return true;
    }
    return false;
}

/**
 * @description 返回缓存的跳转前的 IUrlObj 对象，若没有返回null
 */
function getJumpInfo(pathname: string = window.location.pathname): IUrlObj | null {
    const jumpInfoObj: IJumpInfoObject = JSON.parse(localStorage.getItem(___REFERER_URL_MAP) || '{}');
    if (jumpInfoObj[pathname]) {
        return jumpInfoObj[pathname];
    }
    return null;
}

function getUrlObj(url: string, params?: IPlainObject): IUrlObj {
    url = url || location.pathname;
    if (url.length > 4 && url.substr(0, 4) !== 'http') {
        url = location.origin + url;
    }
    const urlObj = new URL(url);
    let search = urlObj.search;

    const newParams = Object.assign(QS.parse(search), GLOBAL_QS, params);

    if (newParams) {
        search = '?';
        search += Object.keys(newParams).map((key) => {
            let value = newParams[key];
            try {
                if (encodeURINames.includes(key)) {
                    value = encodeURIComponent(value);
                }
            } catch(err) {
                console.error(err);
            }
           return key + '=' + value;
        }).join('&');
    }
    return {
        pathname: urlObj.pathname,
        search: search,
    };
}

const GLOBAL_QS = {};
function handleGLOBAL_QS(objs, key: string) {
    let val = objs[key];
    if (Array.isArray(val)) {
        val = val[0];
        GLOBAL_QS[key] = val;
    } else if (val) {
        GLOBAL_QS[key] = val;
    }
}
export function initGlobalQS(...keys: string[]) {
    const objs = QS.parse(location.search);
    keys.forEach(key => {
        handleGLOBAL_QS(objs, key);
    });
}

export const router = {
    renderRouterEntry(props = {}) {
        return <RouterEntry { ...props } />;
    },
    routerProps,
    initGlobalQS, // 此处三个 GlobalQS 方法仅给全局组件使用，全局 QueryString
    getGlobalQS(): IPlainObject {
        return GLOBAL_QS;
    },
    getHash() {
        return location.hash && location.hash.slice(1) || '';
    },
    getQueryVal(key: string): string | null {
        const queryParms = new URLSearchParams(location.search);
        return queryParms.get(key);
    },
    setGlobalQS(params?: IPlainObject) {
        Object.assign(GLOBAL_QS, params);
        router.replace(location.pathname, { ...QS.parse(location.search), ...GLOBAL_QS });
    },
    push(url: string, params?: IPlainObject) {
        triggerJumpTrackReport('routerPush', url);
        routerProps.history && storeJumpInfo(url);
        routerProps.history && routerProps.history.push(getUrlObj(url, params));
    },
    replace(url: string, params?: IPlainObject) {
        triggerJumpTrackReport('routerReplace', url);
        routerProps.history && routerProps.history.replace(getUrlObj(url, params));
    },
    reload(url?: string, params?: IPlainObject | string) {
        url = url || (location.pathname + location.search);
        if (params) {
            if (typeof params === 'string') {
                if (params.length > 0) {
                    url += params.charAt(0) === '?' ? params : ('?' + params);
                }
            } else {
                url += QS.stringify(params);
            }
        }
        routerProps.history && routerProps.history.push(getUrlObj(RedirectRouter, {
            r: encodeURIComponent(url),
        }));
    },
    path: '/',
    getUrlObj,
    getUrlString(url: string, params?: IPlainObject): string {
        const urlObj = getUrlObj(url, params);
        return urlObj.pathname + urlObj.search;
    },
    storeJumpInfo,
    hasJumpInfo,
    getJumpInfo,
};

export default router;
